export default "__VITE_ASSET__9c27b61e__"